import React, { useState } from "react";
import classes from "src/components/Welcome/Welcome.module.scss";
 import { useTranslation } from "react-i18next";
 import { forgotPasswordEmail } from "src/api/user-api";
   import type { AxiosError, AxiosResponse } from "axios";
import { useSearchParams } from "react-router-dom";
    import type { ResetUserModel} from "src/interfaces/ResetUser";
      import { CustomLoader } from "src/components";   
      import { useParams ,useNavigate} from "react-router-dom"; 
export default function ForgotPassword() {
      const [username, setUsername] = useState("");
       
       const { t } = useTranslation();
      const [apiError, setApiError] = useState<string | null>(null);
 const navigate = useNavigate();
        
      const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
         const validateRegister = () => {
  const newErrors: Record<string, string> = {};

  
  if (!username.trim()) newErrors.username = "Email is required";
   

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
      
        function sendForgotPasswordEmail(){
          const isValid = validateRegister();
          if(isValid){
            setIsLoading(true);
           const data: ResetUserModel = {
                           emailAddress: username,
                           id:0,
                           password:""
                            //token:tokens
                           // add other IUser fields if required
                         };
forgotPasswordEmail(data)
   .then((res: AxiosResponse) => {
    setUsername('');
     setIsLoading(false);
     setApiError(res.data)
    return;
   }).catch((err: AxiosError) => {
         setIsLoading(false);
         if(err.response){
          setApiError(err.response.data as string)
         }
        })
    }
    
    }
    if (apiError !=null) {
  return (
    <div className={classes.PasswordWrapper}>
    <div className={classes.Header}>
      <div className={classes.LoginTitle}>
        {apiError}
      </div>

      <button
        className={classes.SignInBtn}
       onClick={() => navigate("/login")}
      >
        Go to Sign In
      </button>
    </div></div>
  );
}
  return (
    <div className={classes.PasswordWrapper}>
          {isLoading &&  <CustomLoader /> }
    <div className={classes.Header}>
          <div className={classes.LoginTitle}>{t("form.forgotPassword")}</div>
          <div className={classes.LoginBox}>
              <span>
       <i className="fa fa-user user-icon"></i>
       </span>
      <input
               type="text"
               placeholder="Email Address"
               value={username}
               onChange={(e) => {
         setUsername(e.target.value);
         setErrors((prev) => ({ ...prev, username: "" }));
       }}
             />
      {errors.username && (
       <span className={classes.ErrorText}>{errors.username}</span>
     )}
     </div>
       
      <button
      type="button" 
      className={classes.SignInBtn}
      onClick={sendForgotPasswordEmail}
    >
     Send Password Reset Email
    </button>
    
    </div>
    </div>
  );
}
